// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"checkbox_wrapper__IP2to","input":"checkbox_input__bBmhF","inner":"checkbox_inner__2E33F","oval":"checkbox_oval__16jYj"};